import React from "react";
import './Resource/Stylesheets/Login.css';
import App, {Var} from "./App";
import User from "./Server/User";
import moment from "jalali-moment";
import {login} from "./Redux/Actions/user";
import Resource from "./Resource";
import ENVErrors from './Project/ENVErrors';
import MyComponent from './Components/MyComponent';
import {connect} from 'react-redux';

class Login extends MyComponent {
    constructor (props) {
        super(props);

        this.state = {
            message: null,
            username: null,
            password: null,
            save: true,
            loading: false
        };

        this.ref = {
            username: React.createRef(),
            password: React.createRef(),
            button: React.createRef()
        };

        if (props.user?.save === false && props.user?.sessionId === App.session.get('sessionId', null))
            props.history.push(Resource.ROUTE.HOME);
        else if (props.user?.save === true && props.user.login_at) // if user is login
            props.history.push(Resource.ROUTE.HOME);
    }

    validations = {
        username: x => Var.isNotVoid(x) || 'نام کاربری وارد نشده است.',
        password: x => Var.isNotVoid(x) || 'رمز عبور وارد نشده است.'
    };

    shouldComponentUpdate (nextProps, nextState, nextContext) {
        return this.state.message !== nextState.message ||
            this.state.loading !== nextState.loading;
    }

    componentDidMount () {
        this.ref.username.current.focus();
    }

    render () {
        return <React.Fragment>
            <ENVErrors/>
            <div className={'Login'}>
                <div className={'Login-block'}>
                    <div className={'Login-right'}>
                        <p className="Login-title">سامانه مدیریت<br/>فرآورده‌های خونی همو</p>
                        <p className={'Login-description'} style={{opacity: 0}}>سامانه مدیریت بانک خون جهت مدیریت بخش های مرتبط با خون در بیمارستان ها و اورژانس های سطح کشور طراحی و پیاده سازی شده است.</p>
                        <div className="dis-f" style={{justifyContent: 'space-around', marginTop: 'auto'}}>
                            <img className={'Login-logo'} src={Resource.IMAGE.LOGO_BLOOD_BANK} alt=""/>
                            <img className={'Login-logo'} src={Resource.IMAGE.LOGO_SELF} alt=""/>
                        </div>
                    </div>
                    <div className={'Login-left'}>
                        <p className={'Login-title'}>ورود</p>
                        <div className="Login-input">
                            <input ref={this.ref.username} type="text" name={'username'} onKeyUp={this.inputKeyUpHandler.bind(this, 'username')} onChange={this.field.bind(this, 'username')} placeholder={'نام کاربری'}/>
                        </div>
                        <div className="Login-input">
                            <input ref={this.ref.password} type="password" name={'password'} onKeyUp={this.inputKeyUpHandler.bind(this, 'password')} onChange={this.field.bind(this, 'password')} placeholder={'رمزعبور'}/>
                        </div>
                        <div className="Login-checkbox">
                            <input type="checkbox" id={'save'} defaultChecked={true} onChange={this.inputChangeHandler.bind(this, 'save')}/>
                            <label htmlFor="save">مرا به خاطر بسپار!</label>
                        </div>
                        {this.state.message && <p className={'Login-message'}>{this.state.message}</p>}
                        <div className="Login-padding"/>
                        <button ref={this.ref.button} className={`Login-button ${this.state.loading ? 'loading' : ''}`} disabled={this.state.loading} onClick={this.submitClickHandler.bind(this)}>ورود</button>
                    </div>
                </div>
            </div>
            <div className={'footer'}>تمامی حقوق این سامانه متعلق به شرکت <a href="https://aftabeshafa.ir/">آفتاب شفا</a> می باشد. <a href="https://aftabeshafa.ir/">پشتیبانی</a> - <a href="https://aftabeshafa.ir/">درباره ما</a></div>
        </React.Fragment>;
    }

    inputChangeHandler (id, event) {
        const state = {...this.state};
        state[id] = event.target.checked;
        this.setState(state);
    }

    inputKeyUpHandler (id, event) {
        if (event.keyCode === 13)
            if (event.target.name === 'username')
                this.ref.password.current.focus();
            else if (event.target.name === 'password')
                this.submitClickHandler();
    }

    submitClickHandler () {
        const {username, password, save} = this.state;
        const userv = this.validations.username(username);
        const passv = this.validations.password(password);
        if (userv !== true || passv !== true) {
            if (userv !== true)
                this.ref.username.current.focus();
            else
                this.ref.password.current.focus();

            this.setState({
                message: userv !== true ? userv : passv
            });
            return;
        }
        this.setState({
            loading: true,
            message: null
        });

        User.login({
            username,
            password,
            save
        }).then(data => {
            this.setState({loading: false});

            this.props.login({...data, login_at: moment().format()});
            this.props.history.push(Resource.ROUTE.HOME);
        }).catch(message => {
            this.setState({
                loading: false,
                message
            });
        });
    }

    field (key, event) {
        const state = {...this.state};
        state[key] = event.target.value;

        this.setState({...state});
    }
}

const mapStateToProps = state => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        login: props => dispatch(login(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);